import { ConfigProvider, Modal } from "antd";
import styled from "styled-components";
import { device } from "../lib/breakpoints";

const CustomModal = ({
  isOpen,
  onClose,
  children,
  showCloseIcon = true,
  isCentered = false,
  width = 395,
  fullScreenOnMobile = false,
  maskClosable = true,
  keyboard = true,
  /** White close icon and frosted control; use when the X sits on a green/dark header. */
  lightCloseForDarkHeader = false,
  ...rest
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorIcon: lightCloseForDarkHeader
            ? "rgba(255, 255, 255, 0.95)"
            : "var(--color-text)",
        },
      }}
    >
      <StyledModal
        $lightCloseIcon={lightCloseForDarkHeader}
        open={isOpen}
        onCancel={onClose}
        footer={[]}
        closable={showCloseIcon}
        centered={isCentered}
        width={width}
        fullScreenOnMobile={fullScreenOnMobile}
        maskClosable={maskClosable}
        keyboard={keyboard}
        {...rest}
      >
        {children}
      </StyledModal>
    </ConfigProvider>
  );
};

export const ModalTitle = styled.div`
  color: var(--color-text);
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
`;

export const ModalDescription = styled.p`
  color: #949ba4;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4rem;
`;

const StyledModal = styled(Modal)`
  .ant-modal-close {
    display: flex !important;
    align-items: center;
    justify-content: center;
    position: relative;
    top: unset;
    inset-inline-end: unset;
    margin-left: auto;
    color: #1e293b !important;
    background: transparent !important;
    border: none !important;
    z-index: 10;
    font-size: 1.5rem;
    width: 44px;
    height: 44px;
    border-radius: 0 !important;
    padding: 0 !important;
    line-height: 1 !important;
    transition:
      background 0.2s,
      color 0.2s,
      border-color 0.2s;

    &,
    .anticon,
    .anticon svg,
    .ant-modal-close-x {
      color: #1e293b !important;
      fill: #1e293b !important;
    }

    &:hover {
      color: #0f172a !important;
      background: transparent !important;
      border-color: transparent !important;
    }

    .anticon:hover,
    &:hover .anticon,
    &:hover .anticon svg {
      color: #0f172a !important;
      fill: #0f172a !important;
    }

    .ant-modal-close-x,
    .ant-modal-close-icon,
    .anticon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      height: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1 !important;
    }

    svg {
      display: block;
      margin: 0 !important;
    }
  }

  .ant-modal-content {
    border-radius: 10px;
    // border: 2px solid var(--color-gray-100);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    background: white;
    max-height: calc(100dvh - 32px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ant-modal-body {
    min-height: 0;
    overflow-y: auto;
  }

  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-footer {
    display: none;
  }

  ${(props) =>
    props.$lightCloseIcon &&
    `
    .ant-modal-close {
      color: #ffffff !important;
      background: transparent !important;
      border: none !important;
    }
    .ant-modal-close,
    .ant-modal-close .anticon,
    .ant-modal-close .anticon svg,
    .ant-modal-close .ant-modal-close-x,
    .ant-modal-close svg {
      color: #ffffff !important;
      fill: #ffffff !important;
    }
    .ant-modal-close:hover {
      color: #ffffff !important;
      background: transparent !important;
      border-color: transparent !important;
    }
    .ant-modal-close:hover .anticon,
    .ant-modal-close:hover .anticon svg,
    .ant-modal-close:hover svg {
      color: #ffffff !important;
      fill: #ffffff !important;
    }
  `}

  ${(props) =>
    props.fullScreenOnMobile &&
    `
    @media ${device.mobile} {
      width: 100vw !important;
      max-width: 100vw !important;
      margin: 0 !important;
      padding: 0 !important;
      top: 0 !important;
      height: 100vh !important;
      
      .ant-modal-content {
        border-radius: 0 !important;
        min-height: 100vh !important;
        padding: 1rem !important;
      }
    }
  `}
`;

export default CustomModal;
